import { Form, Link, redirect } from "react-router-dom";

import { logout } from "@src/features/auth";
import { queryClient } from "@src/queryClient";

export function meta() {
  return [{ title: "Logout" }, { name: "description", content: "Sign out" }];
}

export async function clientAction() {
  await logout(queryClient);
  return redirect("/login");
}

export default function Logout() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <p>Are you sure you want to log out?</p>
      <Form method="post">
        <button type="submit">Logout</button>
      </Form>
      <Link to="/dashboard">Never mind</Link>
    </div>
  );
}
